<template>
<div class="page">
<div class="title">最新のプッシュ</div>
<!--  列表-->
  <div class="content">
    <div v-for="(item,index) in leftList" :key="index">
    <div class="list" @click="hadleDetails(item)">
      <div style="white-space: nowrap">{{extractYMD(item.updateTime)}}</div>
      <div class="list-title" >{{ item.title }}</div>
    </div>
    </div>
<!--    <div class="list"  @click="hadleDetails">-->
<!--      <div style="white-space: nowrap">2025-12-08</div>-->
<!--      <div>私人定制路線私人定制路線私人定制路線私人定制路線私人定制路線</div>-->
<!--    </div>-->
  </div>
<!--按钮-->
  <div class ="button">
<!--  <div class="back-btn">-->
<!--    <span class="iconfont icon-zuojiantou icon-button"></span>-->
<!--  </div>-->
  <div class="page-btn">
  <div class="back-btn-small" @click="previous">
    <div  :class="params.pageNo > 1? 'btn-small-active' : 'btn-small-no'" >
      <span class="iconfont icon-zuojiantou icon-button"></span>
    </div>

    <div  :class="params.pageNo > 1? 'back-btn-small-text' : 'back-btn-small-text-no'"  >前のページ</div>
  </div>

    <div class="back-btn-small" @click="next">
      <div  :class="params.pageNo * params.pageSize > total? 'btn-small-no' : 'btn-small-active'">
        <span class="iconfont icon-youjiantou icon-button"></span>
      </div>

      <div  :class="params.pageNo * params.pageSize > total? 'back-btn-small-text-no'  : 'back-btn-small-text'"  >次ページ</div>
    </div>
  </div>

  </div>

</div>
</template>
<script >
import { getDynamic } from '@/api/push'
export default {
  name: 'pushDetails',
  data() {
    return {
      lang: 'ja',
      leftList:[],
      total:0,
      params:{
        pageNo:1,
        pageSize:10
      }
    }
  },
  created() {
    this.getDynamic()
  },
  methods: {
    getDynamic() {
      getDynamic(this.params).then(res => {
        this.leftList = res.data.list
        this.total = res.data.total
      })
    },
    previous(){
      if(this.params.pageNo > 1){
        this.params.pageNo = this.params.pageNo - 1
        this.getDynamic()
      }
    },
    next(){
      if(this.params.pageNo * this.params.pageSize >= this.total){
        return
      }
      this.params.pageNo = this.params.pageNo + 1
      this.getDynamic()
    },
    extractYMD(dateTimeStr) {
      // 使用split方法按照"-"和" "进行分割
      // 首先分割出年月日部分（"YYYY-MM-DD"），然后再忽略时间和剩余的部分
      const parts = dateTimeStr.split(' ')[0].split('-')

      // 确保我们得到了正确的部分数量
      if (parts.length === 3) {
        // 返回组合后的年月日字符串
        return parts[0] + '-' + parts[1] + '-' + parts[2]
      } else {
        // 如果格式不正确，返回空字符串或错误消息
        return ''
      }
    },
    hadleDetails(e) {
      this.$router.push(`/push-details/${e.id}`);
    }
  }
}
</script>
<style scoped lang="scss">
.page{
  padding-bottom: 107px;
  @media (max-width: $mobile-breakpoint) {
    min-height: 80.2vh;
    padding-top: 30px;
    padding-bottom: 0;
  }
  .title{
    color: #303030;
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px; /* 105% */
    letter-spacing: 0.32px;
    padding-left: 80px;
    padding-top: 30px;
    padding-bottom: 60px;
    @media (max-width: $mobile-breakpoint) {
      font-size: 13px;
      //display: none;
      //width: 152px;
      //line-height: 26px;
      //margin-left: 124px;
    }
  }

  .content{
    padding: 0 80px 80px;
  }
  .list{
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 32px;
    padding-bottom: 32px;
    padding-top: 36px;
    border-bottom: 1px solid #E2E2E2;
  }
  .list-title{
    white-space: nowrap;      /* 强制文本不换行 */
    overflow: hidden;         /* 隐藏超出部分 */
    text-overflow: ellipsis;  /* 超出部分显示省略号 */
    width: 100%;
  }
  .button{
    display: flex;
    align-items: center;
    padding: 0 340px;
    gap: 146px;
    cursor: pointer;
    white-space: nowrap;

  }
  .back-btn{
    border-radius: 54px;
    background: rgba(66, 66, 69, 0.72);
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-button {
    font-size: 25.5px;
    color: $light-color;
  }
  .page-btn{
    display: flex;
    align-items: center;
    gap: 376px;
  }
  .back-btn-small{
    display: flex;
    align-items: center;
    gap: 30px;
  }
  .btn-small-active{
    border-radius: 54px;
    background: rgba(66, 66, 69, 0.72);
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-small-no{
    border-radius: 54px;
    background: #CACACB;
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .back-btn-small-text{
    color: #454545!important;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .back-btn-small-text-no{
    color: #CACACB!important;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}
</style>
